import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";


export const styles = {
  autocomplete: {
    width: 300,
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: (theme) => theme.palette.grey[400],
      },
      "&:hover fieldset": {
        borderColor: (theme) => theme.palette.jigsaw.green,
      },
      "&.Mui-focused fieldset": {
        borderColor: (theme) => theme.palette.jigsaw.green,
        borderWidth: 2,
      },
    },
    "& .MuiInputLabel-root": {
      color: (theme) => theme.palette.grey[600],
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: (theme) => theme.palette.jigsaw.green,
    },
  },
};

export const CreatableComboBoxContainer = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
    width: "95%",
    alignItems: "center",
    justifyContent: "center",
    marginLeft:"10px",
    padding: "15px",
}));